<!--English Version-->
<section *ngIf="language === 'en'">
    <div class="container-fluid">
        <h2>Available Documents</h2>
        <br>
        <ul class="list-group" style="margin-top:7px">
            <ng-template [ngTemplateOutlet]="helpDocumentsTemplate"></ng-template>
        </ul>
    </div>
</section>
<!--Spanish Version-->
<section *ngIf="language === 'es'">
    <div class="container-fluid">
        <h2>Documentos disponibles</h2>
        <br>
        <ul class="list-group" style="margin-top:7px">
            <ng-template [ngTemplateOutlet]="helpDocumentsTemplate"></ng-template>
        </ul>
    </div>
</section>
<!--German Version - TODO-->
<section *ngIf="language === 'de'">
    <div class="container-fluid">
        <h2>Verfügbare Anhänge</h2>
        <br>
        <ul class="list-group" style="margin-top:7px">
            <ng-template [ngTemplateOutlet]="helpDocumentsTemplate"></ng-template>
        </ul>
    </div>
</section>

<ng-template #helpDocumentsTemplate>
    <div *ngIf="!loading && helpDocuments.length === 0">{{'NO-DOCUMENTS-FOUND' | translate}}
    </div>
    <div *ngIf="loading" class="row justify-content-center">
        <span class="k-icon k-i-loading kendo-loading-icon"></span>
    </div>
    <li class="list-group-item" *ngFor="let item of helpDocuments">
        <a *ngIf="item.type === 'DOCUMENT'" class="pointer" (click)="saveFileLocal(item.document.url,item.name)"
            title="{{ 'DOWNLOAD' | translate }} {{item.name}}">
            <i class="fa {{getFileTypeClass(item.document.mimeType)}} fa-1_5x"></i>&nbsp;
            {{item.name}}
        </a>
        <a *ngIf="item.type === 'URL'" class="pointer" (click)="openHelpUrl(item.url)">
            <i class="fas fa-link fa-fw"></i>&nbsp;
            {{item.name}}
        </a>
    </li>
</ng-template>